
import { Component, Vue, Watch } from "vue-property-decorator";
import Scan from "@/components/Scan.vue";
import TagList from "@/components/shared/TagList.vue";
import BatchRefInput from "@/components/BatchRefInput.vue";
import BatchQuantityInput from "@/components/BatchQuantityInput.vue";
import NotesInput from "@/components/NotesInput.vue";
import TotalTagsScanned from "@/components/TotalTagsScanned.vue";
import { withdrawalDaysFromToday } from "@/helpers/withdrawal";
import * as Models from "@gigalot/data-models";
import lodash from "lodash";

@Component({
  components: {
    Scan,
    TagList,
    BatchRefInput,
    BatchQuantityInput,
    NotesInput,
    TotalTagsScanned,
  },
})
export default class Count extends Vue {
  batchNumber: string = "";
  batchQuantity: string = "";
  notes: string = "";
  isUiLocked: boolean = false;

  created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => {
        this.$router.go(-1);
      },
    });
  }

  onClearWhenSaved() {
    this.batchNumber = "";
    this.batchQuantity = "";
    this.notes = "";
    this.$store.commit("dispatchToAbattoir/batchQuantity", "");
    this.$store.commit("dispatchToAbattoir/batchNumber", "");
    this.$store.commit("dispatchToAbattoir/notes", "");
  }

  sgtins: string[] = [];
  animals: (Models.Animal & { withdrawalDays?: number })[] = [];

  get tags() {
    const tags: Models.Tag[] = this.$store.state.scan.tags;
    this.sgtins = tags.map((t) => t.sgtin);
    return this.$store.state.scan.tags;
  }

  get withdrawalAnimalsCount(): number {
    return this.animals.filter((a) => a.withdrawalDays !== undefined && a.withdrawalDays > 0).length;
  }

  @Watch("sgtins")
  onSgtinsChanged(val: string[], oldVal: string[]) {
    const newSgtins = lodash.difference(val, oldVal); //only lookup new sgtins, otherwise it seems that the system looks up too many of the same animals
    const addAnimal = async (sgtin: string) => {
      const animal = await this.$store.dispatch("data/getAnimal", sgtin);
      if (animal) {
        animal.withdrawalDays = withdrawalDaysFromToday(animal);
        this.animals.push(animal);
      }
    };
    for (const sgtin of newSgtins) addAnimal(sgtin);

    //filter out any animals with sgtin no longer being used
    this.animals = this.animals.filter((a) => this.sgtins.find((sgtin) => a.sgtin === sgtin) !== undefined);
  }

  @Watch("batchNumber")
  async onBatchNumberChanged(val: any, oldVal: any) {
    this.$store.commit("dispatchToAbattoir/batchNumber", val);
  }

  @Watch("batchQuantity")
  async onBatchQuantityChanged(val: any, oldVal: any) {
    this.$store.commit("dispatchToAbattoir/batchQuantity", parseInt(val));
  }

  @Watch("notes")
  async onNotesChanged(val: any, oldVal: any) {
    this.$store.commit("dispatchToAbattoir/notes", val);
  }

  async mounted() {
    this.$store.commit("scan/setAppMode", "dispatch-to-abattoir");

    if (this.$store.state.scan.appState === "saving") {
      this.$store.commit("scan/flagError");
    }
    this.$store.dispatch("power/setPowerMode", "high");

    //await this.$store.dispatch("data/linkSgtinsToAnimalsFromDb", this.tags);

    if (this.tags.length > 0) {
      this.batchQuantity = this.$store.state.dispatchToAbattoir.batchQuantity ?? "";
      this.batchNumber = this.$store.state.dispatchToAbattoir.batchNumber || "";
      this.notes = this.$store.state.dispatchToAbattoir.notes || "";
    } else {
      this.$store.commit("dispatchToAbattoir/batchQuantity", "");
      this.$store.commit("dispatchToAbattoir/batchNumber", "");
      this.$store.commit("dispatchToAbattoir/notes", "");
    }
  }

  async onSave() {
    await this.$store.dispatch("dispatchToAbattoir/save");
    this.isUiLocked = true;
  }
}
